import clsx from 'clsx';
import React from 'react';
import Spinner from '../../Spinner/Spinner';

import './SurveyLoader.scss';

type SurveyLoaderProps = {
  isLoading: boolean;
};

export const SurveyLoader: React.FC<SurveyLoaderProps> = ({ isLoading }) => {
  return (
    <div className={clsx('survey-load-btn', { 'm-hide': !isLoading })}>
      <Spinner isDark />
    </div>
  );
};
